import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineComment } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { getCommunityUsers } from "../../../Redux/communitySlice";
import { useEffect } from "react";
import CommunityUsersTable from "../Table/CommunityUsersTable";

const CommunityView = ({ onCancel, inputValue, Id2 }) => {

    const dispatch = useDispatch();
    const selector = useSelector((state) => state);

    const { communitySlice: { getCommunityUsersData = [] } } = selector ? selector : {}

    useEffect(() => {
        dispatch(getCommunityUsers({ postId: Id2 }))
    }, [dispatch, Id2])

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 backdrop-blur-sm z-50">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col mx-2">
                {/* Header */}
                <div className='w-full flex justify-between items-center p-6 border-b'>
                    <div className="flex items-center space-x-3">
                        <div>
                            <h2 className='text-xl font-semibold text-gray-800'>{"Community Users"}</h2>
                            {inputValue?.desc && (
                                <p className='text-gray-600 text-sm mt-1'>{inputValue?.desc}</p>
                            )}
                        </div>
                    </div>
                    <button
                        onClick={onCancel}
                        className='w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors flex justify-center items-center'
                        aria-label="Close"
                    >
                        <IoCloseOutline size={24} />
                    </button>
                </div>


                {/* Content area */}
                <div className="py-6">
                    <div className="">
                        <CommunityUsersTable data={getCommunityUsersData} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunityView;